// eslint-disable-next-line no-shadow
export enum NoAvailableSlotsDataHooks {
  NO_AVAILABLE_SLOTS_WRAPPER = 'no-available-slots-wrapper',
  NO_AVAILABLE_SLOTS = 'no-available-slots',
  NO_AVAILABLE_SLOTS_LINK = 'no-available-slots-link',
}
